import { render, staticRenderFns } from "./NewEditProfissionalDeApoioPage.vue?vue&type=template&id=55a4f267"
import script from "./NewEditProfissionalDeApoioPage.vue?vue&type=script&lang=js"
export * from "./NewEditProfissionalDeApoioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports